@if (facility$ | async; as facility) {
  @if (installation$ | async; as installation) {
    @if (visible$ | async) {
      <gbc-table [clickableRows]="clickable" [ngStyle]="{'min-height': minHeight}" data-test-id="alarm-settings-table">
        <th gbc-table-header>{{ 'alarm-settings-table.table-header-alarm' | translate }}</th>
        <th gbc-table-header>{{ 'alarm-settings-table.table-header-application' | translate }}</th>
        @for (info of alarmSettingsInfo$ | async; track info) {
          <tr gbc-table-row (rowClicked)="settingsClick.emit(info)">
            <td gbc-table-cell>{{ info.alarmSettings.errorCode + ': ' + info.alarmTitle }}</td>
            <td gbc-table-cell>{{ info.applicationTitle }}</td>
          </tr>
        }
      </gbc-table>
    } @else {
      <div class="container-empty" [ngStyle]="{'min-height': minHeight}">
        <div>{{ noAlarmSettingsMessage }}</div>
      </div>
    }
  }
}
